<template>
  <div id="PatientRegistrationModal" class="modal fade" role="dialog" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog wider-1">
      <!-- Modal content-->
      <div class="modal-content room-book-modal">
        <div class="modal-header">

          <button type="button" v-on:click="closeBookAppointment('closepopup')" class="close"
            data-dismiss="modal">&times;</button>
        </div>

        <div class="modal-body ">
          <div v-if="isAbhaEnabled" class="clearfix d-flex justify-content-center mb-5">
            <button class="primary-btn ripple mr-4" @click="navigatetomonecreate()">Create ABHA</button>
            <button class="primary-btn ripple" @click="navigatetomoneverify()">Already has ABHA</button>
          </div>
         <h4 class="modal-title">{{ isEditMode ? 'Update Patient Details' : 'Patient Registration' }}</h4>
          <div class="row">
            <div class="col-lg-6">
              <div class="row">
                <div class="col-2 pr-0">
                  <form class="select-dots" v-bind:class="{ 'disable-hold': selectededitappointment }">
                    <!-- <select name id="cusSelectbox" class data-toggle="tooltip" title="India">
                      <option value="India">+91</option>
                      <option value="UK">+10</option>
                      <option value="USA">+11</option>
                    </select>-->
                    <select name id="cusSelectbox" class="country-code" v-model="countrycode" data-toggle="tooltip"
                      @change="setCcode" @focusin="mobfocus(true)" @focusout="mobfocus(false)" :disabled="isEditMode"
                      :class="mobHasfocus ? 'country-c' : ''">
                      <!-- <option value="91">IND</option>
                      <option value="44">UK</option>
                      <option value="1">USA</option> -->

                      <option data-countrycode="IN" value="91">India (+91)</option>
                      <option data-countrycode="GB" value="44">UK (+44)</option>
                      <option data-countrycode="US" value="1">USA (+1)</option>
                      <optgroup label="Other countries">
                        <option data-countrycode="DZ" value="213">Algeria (+213)</option>
                        <option data-countrycode="AD" value="376">Andorra (+376)</option>
                        <option data-countrycode="AO" value="244">Angola (+244)</option>
                        <option data-countrycode="AI" value="1264">Anguilla (+1264)</option>
                        <option data-countrycode="AG" value="1268">Antigua &amp; Barbuda (+1268)</option>
                        <option data-countrycode="AR" value="54">Argentina (+54)</option>
                        <option data-countrycode="AM" value="374">Armenia (+374)</option>
                        <option data-countrycode="AW" value="297">Aruba (+297)</option>
                        <option data-countrycode="AU" value="61">Australia (+61)</option>
                        <option data-countrycode="AT" value="43">Austria (+43)</option>
                        <option data-countrycode="AZ" value="994">Azerbaijan (+994)</option>
                        <option data-countrycode="BS" value="1242">Bahamas (+1242)</option>
                        <option data-countrycode="BH" value="973">Bahrain (+973)</option>
                        <option data-countrycode="BD" value="880">Bangladesh (+880)</option>
                        <option data-countrycode="BB" value="1246">Barbados (+1246)</option>
                        <option data-countrycode="BY" value="375">Belarus (+375)</option>
                        <option data-countrycode="BE" value="32">Belgium (+32)</option>
                        <option data-countrycode="BZ" value="501">Belize (+501)</option>
                        <option data-countrycode="BJ" value="229">Benin (+229)</option>
                        <option data-countrycode="BM" value="1441">Bermuda (+1441)</option>
                        <option data-countrycode="BT" value="975">Bhutan (+975)</option>
                        <option data-countrycode="BO" value="591">Bolivia (+591)</option>
                        <option data-countrycode="BA" value="387">Bosnia Herzegovina (+387)</option>
                        <option data-countrycode="BW" value="267">Botswana (+267)</option>
                        <option data-countrycode="BR" value="55">Brazil (+55)</option>
                        <option data-countrycode="BN" value="673">Brunei (+673)</option>
                        <option data-countrycode="BG" value="359">Bulgaria (+359)</option>
                        <option data-countrycode="BF" value="226">Burkina Faso (+226)</option>
                        <option data-countrycode="BI" value="257">Burundi (+257)</option>
                        <option data-countrycode="KH" value="855">Cambodia (+855)</option>
                        <option data-countrycode="CM" value="237">Cameroon (+237)</option>
                        <option data-countrycode="CA" value="1">Canada (+1)</option>
                        <option data-countrycode="CV" value="238">Cape Verde Islands (+238)</option>
                        <option data-countrycode="KY" value="1345">Cayman Islands (+1345)</option>
                        <option data-countrycode="CF" value="236">Central African Republic (+236)</option>
                        <option data-countrycode="CL" value="56">Chile (+56)</option>
                        <option data-countrycode="CN" value="86">China (+86)</option>
                        <option data-countrycode="CO" value="57">Colombia (+57)</option>
                        <option data-countrycode="KM" value="269">Comoros (+269)</option>
                        <option data-countrycode="CG" value="242">Congo (+242)</option>
                        <option data-countrycode="CK" value="682">Cook Islands (+682)</option>
                        <option data-countrycode="CR" value="506">Costa Rica (+506)</option>
                        <option data-countrycode="HR" value="385">Croatia (+385)</option>
                        <option data-countrycode="CU" value="53">Cuba (+53)</option>
                        <option data-countrycode="CY" value="90392">Cyprus North (+90392)</option>
                        <option data-countrycode="CY" value="357">Cyprus South (+357)</option>
                        <option data-countrycode="CZ" value="42">Czech Republic (+42)</option>
                        <option data-countrycode="DK" value="45">Denmark (+45)</option>
                        <option data-countrycode="DJ" value="253">Djibouti (+253)</option>
                        <option data-countrycode="DM" value="1809">Dominica (+1809)</option>
                        <option data-countrycode="DO" value="1809">Dominican Republic (+1809)</option>
                        <option data-countrycode="EC" value="593">Ecuador (+593)</option>
                        <option data-countrycode="EG" value="20">Egypt (+20)</option>
                        <option data-countrycode="SV" value="503">El Salvador (+503)</option>
                        <option data-countrycode="GQ" value="240">Equatorial Guinea (+240)</option>
                        <option data-countrycode="ER" value="291">Eritrea (+291)</option>
                        <option data-countrycode="EE" value="372">Estonia (+372)</option>
                        <option data-countrycode="ET" value="251">Ethiopia (+251)</option>
                        <option data-countrycode="FK" value="500">Falkland Islands (+500)</option>
                        <option data-countrycode="FO" value="298">Faroe Islands (+298)</option>
                        <option data-countrycode="FJ" value="679">Fiji (+679)</option>
                        <option data-countrycode="FI" value="358">Finland (+358)</option>
                        <option data-countrycode="FR" value="33">France (+33)</option>
                        <option data-countrycode="GF" value="594">French Guiana (+594)</option>
                        <option data-countrycode="PF" value="689">French Polynesia (+689)</option>
                        <option data-countrycode="GA" value="241">Gabon (+241)</option>
                        <option data-countrycode="GM" value="220">Gambia (+220)</option>
                        <option data-countrycode="GE" value="7880">Georgia (+7880)</option>
                        <option data-countrycode="DE" value="49">Germany (+49)</option>
                        <option data-countrycode="GH" value="233">Ghana (+233)</option>
                        <option data-countrycode="GI" value="350">Gibraltar (+350)</option>
                        <option data-countrycode="GR" value="30">Greece (+30)</option>
                        <option data-countrycode="GL" value="299">Greenland (+299)</option>
                        <option data-countrycode="GD" value="1473">Grenada (+1473)</option>
                        <option data-countrycode="GP" value="590">Guadeloupe (+590)</option>
                        <option data-countrycode="GU" value="671">Guam (+671)</option>
                        <option data-countrycode="GT" value="502">Guatemala (+502)</option>
                        <option data-countrycode="GN" value="224">Guinea (+224)</option>
                        <option data-countrycode="GW" value="245">Guinea - Bissau (+245)</option>
                        <option data-countrycode="GY" value="592">Guyana (+592)</option>
                        <option data-countrycode="HT" value="509">Haiti (+509)</option>
                        <option data-countrycode="HN" value="504">Honduras (+504)</option>
                        <option data-countrycode="HK" value="852">Hong Kong (+852)</option>
                        <option data-countrycode="HU" value="36">Hungary (+36)</option>
                        <option data-countrycode="IS" value="354">Iceland (+354)</option>
                        <option data-countrycode="ID" value="62">Indonesia (+62)</option>
                        <option data-countrycode="IR" value="98">Iran (+98)</option>
                        <option data-countrycode="IQ" value="964">Iraq (+964)</option>
                        <option data-countrycode="IE" value="353">Ireland (+353)</option>
                        <option data-countrycode="IL" value="972">Israel (+972)</option>
                        <option data-countrycode="IT" value="39">Italy (+39)</option>
                        <option data-countrycode="JM" value="1876">Jamaica (+1876)</option>
                        <option data-countrycode="JP" value="81">Japan (+81)</option>
                        <option data-countrycode="JO" value="962">Jordan (+962)</option>
                        <option data-countrycode="KZ" value="7">Kazakhstan (+7)</option>
                        <option data-countrycode="KE" value="254">Kenya (+254)</option>
                        <option data-countrycode="KI" value="686">Kiribati (+686)</option>
                        <option data-countrycode="KP" value="850">Korea North (+850)</option>
                        <option data-countrycode="KR" value="82">Korea South (+82)</option>
                        <option data-countrycode="KW" value="965">Kuwait (+965)</option>
                        <option data-countrycode="KG" value="996">Kyrgyzstan (+996)</option>
                        <option data-countrycode="LA" value="856">Laos (+856)</option>
                        <option data-countrycode="LV" value="371">Latvia (+371)</option>
                        <option data-countrycode="LB" value="961">Lebanon (+961)</option>
                        <option data-countrycode="LS" value="266">Lesotho (+266)</option>
                        <option data-countrycode="LR" value="231">Liberia (+231)</option>
                        <option data-countrycode="LY" value="218">Libya (+218)</option>
                        <option data-countrycode="LI" value="417">Liechtenstein (+417)</option>
                        <option data-countrycode="LT" value="370">Lithuania (+370)</option>
                        <option data-countrycode="LU" value="352">Luxembourg (+352)</option>
                        <option data-countrycode="MO" value="853">Macao (+853)</option>
                        <option data-countrycode="MK" value="389">Macedonia (+389)</option>
                        <option data-countrycode="MG" value="261">Madagascar (+261)</option>
                        <option data-countrycode="MW" value="265">Malawi (+265)</option>
                        <option data-countrycode="MY" value="60">Malaysia (+60)</option>
                        <option data-countrycode="MV" value="960">Maldives (+960)</option>
                        <option data-countrycode="ML" value="223">Mali (+223)</option>
                        <option data-countrycode="MT" value="356">Malta (+356)</option>
                        <option data-countrycode="MH" value="692">Marshall Islands (+692)</option>
                        <option data-countrycode="MQ" value="596">Martinique (+596)</option>
                        <option data-countrycode="MR" value="222">Mauritania (+222)</option>
                        <option data-countrycode="YT" value="269">Mayotte (+269)</option>
                        <option data-countrycode="MX" value="52">Mexico (+52)</option>
                        <option data-countrycode="FM" value="691">Micronesia (+691)</option>
                        <option data-countrycode="MD" value="373">Moldova (+373)</option>
                        <option data-countrycode="MC" value="377">Monaco (+377)</option>
                        <option data-countrycode="MN" value="976">Mongolia (+976)</option>
                        <option data-countrycode="MS" value="1664">Montserrat (+1664)</option>
                        <option data-countrycode="MA" value="212">Morocco (+212)</option>
                        <option data-countrycode="MZ" value="258">Mozambique (+258)</option>
                        <option data-countrycode="MN" value="95">Myanmar (+95)</option>
                        <option data-countrycode="NA" value="264">Namibia (+264)</option>
                        <option data-countrycode="NR" value="674">Nauru (+674)</option>
                        <option data-countrycode="NP" value="977">Nepal (+977)</option>
                        <option data-countrycode="NL" value="31">Netherlands (+31)</option>
                        <option data-countrycode="NC" value="687">New Caledonia (+687)</option>
                        <option data-countrycode="NZ" value="64">New Zealand (+64)</option>
                        <option data-countrycode="NI" value="505">Nicaragua (+505)</option>
                        <option data-countrycode="NE" value="227">Niger (+227)</option>
                        <option data-countrycode="NG" value="234">Nigeria (+234)</option>
                        <option data-countrycode="NU" value="683">Niue (+683)</option>
                        <option data-countrycode="NF" value="672">Norfolk Islands (+672)</option>
                        <option data-countrycode="NP" value="670">Northern Marianas (+670)</option>
                        <option data-countrycode="NO" value="47">Norway (+47)</option>
                        <option data-countrycode="OM" value="968">Oman (+968)</option>
                        <option data-countrycode="PW" value="680">Palau (+680)</option>
                        <option data-countrycode="PA" value="507">Panama (+507)</option>
                        <option data-countrycode="PG" value="675">Papua New Guinea (+675)</option>
                        <option data-countrycode="PY" value="595">Paraguay (+595)</option>
                        <option data-countrycode="PE" value="51">Peru (+51)</option>
                        <option data-countrycode="PH" value="63">Philippines (+63)</option>
                        <option data-countrycode="PL" value="48">Poland (+48)</option>
                        <option data-countrycode="PT" value="351">Portugal (+351)</option>
                        <option data-countrycode="PR" value="1787">Puerto Rico (+1787)</option>
                        <option data-countrycode="QA" value="974">Qatar (+974)</option>
                        <option data-countrycode="RE" value="262">Reunion (+262)</option>
                        <option data-countrycode="RO" value="40">Romania (+40)</option>
                        <option data-countrycode="RU" value="7">Russia (+7)</option>
                        <option data-countrycode="RW" value="250">Rwanda (+250)</option>
                        <option data-countrycode="SM" value="378">San Marino (+378)</option>
                        <option data-countrycode="ST" value="239">Sao Tome &amp; Principe (+239)</option>
                        <option data-countrycode="SA" value="966">Saudi Arabia (+966)</option>
                        <option data-countrycode="SN" value="221">Senegal (+221)</option>
                        <option data-countrycode="CS" value="381">Serbia (+381)</option>
                        <option data-countrycode="SC" value="248">Seychelles (+248)</option>
                        <option data-countrycode="SL" value="232">Sierra Leone (+232)</option>
                        <option data-countrycode="SG" value="65">Singapore (+65)</option>
                        <option data-countrycode="SK" value="421">Slovak Republic (+421)</option>
                        <option data-countrycode="SI" value="386">Slovenia (+386)</option>
                        <option data-countrycode="SB" value="677">Solomon Islands (+677)</option>
                        <option data-countrycode="SO" value="252">Somalia (+252)</option>
                        <option data-countrycode="ZA" value="27">South Africa (+27)</option>
                        <option data-countrycode="ES" value="34">Spain (+34)</option>
                        <option data-countrycode="LK" value="94">Sri Lanka (+94)</option>
                        <option data-countrycode="SH" value="290">St. Helena (+290)</option>
                        <option data-countrycode="KN" value="1869">St. Kitts (+1869)</option>
                        <option data-countrycode="SC" value="1758">St. Lucia (+1758)</option>
                        <option data-countrycode="SD" value="249">Sudan (+249)</option>
                        <option data-countrycode="SR" value="597">Suriname (+597)</option>
                        <option data-countrycode="SZ" value="268">Swaziland (+268)</option>
                        <option data-countrycode="SE" value="46">Sweden (+46)</option>
                        <option data-countrycode="CH" value="41">Switzerland (+41)</option>
                        <option data-countrycode="SI" value="963">Syria (+963)</option>
                        <option data-countrycode="TW" value="886">Taiwan (+886)</option>
                        <option data-countrycode="TJ" value="7">Tajikstan (+7)</option>
                        <option data-countrycode="TH" value="66">Thailand (+66)</option>
                        <option data-countrycode="TG" value="228">Togo (+228)</option>
                        <option data-countrycode="TO" value="676">Tonga (+676)</option>
                        <option data-countrycode="TT" value="1868">Trinidad &amp; Tobago (+1868)</option>
                        <option data-countrycode="TN" value="216">Tunisia (+216)</option>
                        <option data-countrycode="TR" value="90">Turkey (+90)</option>
                        <option data-countrycode="TM" value="7">Turkmenistan (+7)</option>
                        <option data-countrycode="TM" value="993">Turkmenistan (+993)</option>
                        <option data-countrycode="TC" value="1649">Turks &amp; Caicos Islands (+1649)</option>
                        <option data-countrycode="TV" value="688">Tuvalu (+688)</option>
                        <option data-countrycode="UG" value="256">Uganda (+256)</option>
                        <option data-countrycode="UA" value="380">Ukraine (+380)</option>
                        <option data-countrycode="AE" value="971">United Arab Emirates (+971)</option>
                        <option data-countrycode="UY" value="598">Uruguay (+598)</option>
                        <option data-countrycode="UZ" value="7">Uzbekistan (+7)</option>
                        <option data-countrycode="VU" value="678">Vanuatu (+678)</option>
                        <option data-countrycode="VA" value="379">Vatican City (+379)</option>
                        <option data-countrycode="VE" value="58">Venezuela (+58)</option>
                        <option data-countrycode="VN" value="84">Vietnam (+84)</option>
                        <option data-countrycode="VG" value="84">Virgin Islands - British (+1284)</option>
                        <option data-countrycode="VI" value="84">Virgin Islands - US (+1340)</option>
                        <option data-countrycode="WF" value="681">Wallis &amp; Futuna (+681)</option>
                        <option data-countrycode="YE" value="969">Yemen (North)(+969)</option>
                        <option data-countrycode="YE" value="967">Yemen (South)(+967)</option>
                        <option data-countrycode="ZM" value="260">Zambia (+260)</option>
                        <option data-countrycode="ZW" value="263">Zimbabwe (+263)</option>
                      </optgroup>
                    </select>
                  </form>
                </div>

                <div class="col-2 px-0">
                  <input @change="setCcode" @focusin="mobfocus(true)" @focusout="mobfocus(false)"
                    :class="mobHasfocus ? 'country-c' : ''" type="text" disabled :value="countrycode"
                    class="w-100 px-2">
                </div>
                <div class="col-8" v-if="abhaprofile == null">
                  <div class="form-group" v-bind:class="{ 'disable-hold': selectededitappointment }">
                    <div class="container-comm" v-bind:class="{ 'error-msg-hold': usermobilenumber }">
                      <input v-if="this.selectededitappointment" v-model="customermobile" class="mobi-num " type="text"
                        autocomplete="off" name="uname" required @keypress="allowOnlyNumbers">
                      <!-- <input v-if="true" class="mobile-number form-control" type="text" v-model="customermobile" autocomplete="off" name="mblnumber" > -->
                      <v-autocomplete v-if="!this.selectededitappointment" ref="newCustomer_autocomplete"
                        name="Mobile Number" data-vv-delay="300" :auto-select-one-item="false" :get-label="getLabel"
                        :items="customers" v-model="customer" :component-item="gtemplate" @update-items="updateItems"
                        @item-selected="customer_selected" @focus="mobfocus(true)" @blur="mobfocus(false)"  @keypress.native="allowOnlyDigits"
                        @change="checkValue" :input-attrs="{
                          id: 'registerpatientautoselect',
                          class: 'mobi-num form-control input', maxlength: 10
                        }" :disabled="readonlyparentdata|| isEditMode"
                        :style="readonlyparentdata ? { color: 'rgba(29, 29, 29, 0.45)' } : {}"></v-autocomplete>

                      <label for="mobile"
                        v-bind:class="{ 'animate-label-t': mobHasfocus, 'animate-label-t t-valid': mobHasfocusout && mobHasfocusoutvalue }">
                        <b>{{ $t('NewMobilenumber') }} </b>
                      </label>
                      <div v-bind:class="{ 'error-msg-hold': mobilenumberdigitisvalid }">
                        <!-- <span v-if="mobHasfocusout" class="error-message err-gender mb-2 pull-left"> {{ $t('Pleaseenterdigitmobilenumber')
                        }} </span> -->
                        <span v-if="mobilenumberdigitisvalid" class="error-message err-gender">Please enter 10 digit mobile number</span>
                      </div>
                      <div v-bind:class="{ 'error-msg-hold': numbervalidationcustomer }">
                        <span v-if="numbervalidationcustomer" class="error-message err-gender pt-2">{{ $t('Onlynumericareallowed') }}</span>
                      </div>

                    </div>
                  </div>
                </div>
                <div class="col-8" v-else>
                  <div class="form-group" v-bind:class="{ 'disable-hold': abhaprofile != null }">

                    <!-- <div class="mobile-no" v-if="true && true">
                    <input class="mobile-number form-control" type="text" v-model="customermobile" autocomplete="off" name="mblnumber" >
                    </div> -->

                    <div class="container-comm" v-bind:class="{ 'disabled': abhaprofile != null }">
                      <input v-model="customermobile" type="text" autocomplete="off" name="uname" required maxlength="10">
                      <label for="fname">
                        <b>Mobile number</b>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <div class="container-comm">
                  <div class="search-by-t">
                    <!-- <input type="text" autocomplete="off" required v-model="registrationid" maxlength="10">
                    <span class="addpre-search"></span>
                    <label>Guest ID</label> -->
                    <v-autocomplete ref="guest_autocomplete" name="Guest ID" :items="guestCustomers"
                      v-model="selectedGuest" :get-label="getGuestLabel" :component-item="gtemplate"
                       :auto-select-one-item="false" :disabled="readonlyparentdata|| isEditMode"
                      @update-items="updateGuestItems" @item-selected="guest_selected" @focus="guestfocus(true)"
                      @blur="guestfocus(false)" :input-attrs="{
                        id: 'patientid_autocomplete',
                        class: 'input form-control',
                        maxlength: 15
                      }" :style="readonlyparentdata ? { color: 'rgba(29, 29, 29, 0.45)' } : {}"></v-autocomplete>

                  <label v-bind:class="{
                      'animate-label-t': guestHasfocus,
                      'animate-label-t t-valid': (guestHasfocusout && guestHasfocusoutvalue) ||
                        (guestHasfocus && selectedGuest)
                    }">
                      Search by Patient ID
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 1 -->
          <div class="row mt-3 mb-3">
            <div class="col-lg-6">
              <div class="form-group">
                <div class="container-comm">
                  <div class="container-comm" v-bind:class="{ 'error-msg-hold': isfirstname }">
                    <input type="text" autocomplete="off" name="uname" v-model="firstName" required maxlength="50"
                      @keypress="allowNameKeyPress" :disabled="readonlyparentdata && !isEditMode">
                    <label for="fname">
                      <b>First name </b>
                    </label>
                    <span v-if="isfirstname && firstName" class="error-message error">{{ $t('Pleaseenteralpahabetical')
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <div class="container-comm" v-bind:class="{ 'error-msg-hold': ismiddlename }">
                  <input type="text" autocomplete="off" name="uname" v-model="middleName" maxlength="50"
                    @keypress="allowNameKeyPress" required :disabled="readonlyparentdata && !isEditMode">
                  <label for="fname">
                    <b>Middle name (Optional) </b>
                  </label>
                  <span v-if="this.ismiddlename && middleName" class="error-message error">{{
                    $t('Pleaseenteralpahabetical') }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-3 mb-3">
            <div class="col-lg-6">
              <div class="form-group">
                <div class="container-comm">
                  <div class="container-comm" v-bind:class="{ 'error-msg-hold': islastname }">
                    <input type="text" autocomplete="off" name="uname" v-model="lastName" required maxlength="50"
                      @keypress="allowNameKeyPress" :disabled="readonlyparentdata && !isEditMode">
                    <label for="fname">
                      <b>Last name </b>
                    </label>
                    <span v-if="this.islastname && lastName" class="error-message error">{{
                      $t('Pleaseenteralpahabetical') }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <div class="container-comm valid1">
                  <div class="container-comm"
                    v-bind:class="{ 'error-msg-hold': isselecteddateofbirth && !dateofbirth }">
                    <input type="text" autocomplete="off" name="uname" required v-model="dateofbirth"
                      @change="updateDOBItems" id="patientsetdateofbirth" class="trans-bg" @input="validateDOBInput" 
                      placeholder="DD-MM-YYYY" @keydown.enter.prevent="onDobEnter" :disabled="(readonlyparentdata && hasValue(dateofbirth))&& !isEditMode">

                    <label class="date-hoverB" for="dateofbirth">
                      <b>DOB </b>
                    </label>
                  </div>
                  <span class="date-field-in"></span>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-lg-6 mt-3">
              <label class="radio-container" v-bind:key="item.value" v-for="item in genderOptions">
                {{ item.text }}
                <input v-model="selectedGender" name="gender" type="radio" :value="item.value" :disabled="readonlyparentdata && !isEditMode">
                <span class="radio-checkmark"></span>
              </label>
              <span v-if="this.usergender && !selectedGender" class="error-message err-gender">{{
                $t('Pleaseselectgender') }}</span>
            </div>
            <div class="col-lg-6" v-if="this.selectededitappointment">
              <div class="form-group" v-bind:class="{ 'disable-hold': selectededitappointment }">
                <div class="container-comm">

                  <input v-model="customeremail" type="text" autocomplete="off" name="uname" maxlength="100"
                    plcaceholder=" " required :disabled="readonlyparentdata && hasValue(customeremail)">
                  <label for="email">
                    <b>{{ $t('EmailOptional') }} <span style=" color: rgb(181 181 181);font-style: italic;"></span></b>
                  </label>


                </div>
              </div>
            </div>
            <div class="col-lg-6" v-if="!this.selectededitappointment">
              <div class="form-group" v-bind:class="{ 'disable-hold': selectededitappointment }">
                <div class="container-comm">
                  <!-- <input type="text" title autocomplete="off" name="uname" required> -->
                  <!-- <input v-model="customeremail" type="text" autocomplete="off" name="uname" required> -->
                  <input v-model="customeremail" type="text" autocomplete="off" name="email" plcaceholder=" " required
                    maxlength="100" @blur="ValidateEmail" :disabled="(readonlyparentdata && hasValue(customeremail))&& !isEditMode">
                  <label for="email">
                    <b>{{ $t('EmailOptional') }} <span style=" color: rgb(181 181 181);font-style: italic;"></span></b>
                  </label>
                  <div class="height-dft m-0">
                    <!-- <div  v-bind:class="{ 'error-msg-hold': useremail && !customeremail}">
                        <span v-if="useremail && !customeremail" class="error">Please enter email</span>
                      </div> -->
                    <div v-bind:class="{ 'error-msg-hold': validationcustomeremail }">
                      <span v-if="validationcustomeremail" class="error">{{ $t('Pleaseentervalidemailaddress') }}</span>

                    </div>

                  </div>

                  <!-- <span v-if="this.useremail && !customeremail" class="error">Please enter email</span> -->
                </div>
              </div>

            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                  <div class="container-comm">
                    <input v-model="address" required maxlength="255" :disabled="(readonlyparentdata && hasValue(address))&& !isEditMode"/>
                    <label for="pname">
                      <b>Address</b>
                    </label>

                  </div>
              </div>
            </div>
          </div>


          <div class="row">
            <div class="col-lg-6 mt-2">
              <div class="add-notes-hold d-none">
                <a href="javascript:void(0);" id="add_category" v-on:click="shownote" class="add-new-btn">
                  {{ !note ? $t('Addnotes') : $t('Viewnotes') }}
                  <i class="material-icons">add</i>
                </a>
              </div>
              <div v-if="!this.selectededitappointment || this.appointmentByEncounter" class="allow-over-hold-saperator"
                hidden></div>
              <div hidden class="allow-over-hold" v-if="!this.selectededitappointment || this.appointmentByEncounter"
                allowOverlapping>
                <label data-toggle="tooltip" data-placement="top" :title="$t('Allowoverlapping')"
                  class="container customcheck splfont-1">
                  <input v-model="allowOverlapping" type="checkbox">
                  <span class="checkmark c-right"></span>
                  {{ $t('Allowoverlapping') }}
                </label>
              </div>
            </div>

            <div class="col-lg-6" v-if="!this.selectededitappointment || this.appointmentByEncounter">
              <div class="pull-right mt-2">
                <button type="button" class="primary-btn ripple"
                  @click="isEditMode ? updateVIPGuest() : registerVIPGuest()" :disabled="isSaving" :class="{'global-disabled':isSaving}">
                  <span>{{ isEditMode ? 'Update' : 'Save' }}</span>
                </button>
              </div>
            </div>
          </div>
          <!-- 8 -->
          <div class="add-categoryst">
            <div class="col-lg-12 mt-3 padr-0 pl-0">
              <div class="form-group">
                <div class="text-2000">{{ totalRemainCount }}/{{ limitmaxCount }}</div>
                <div class="container-TXT">
                  <!-- <textarea rows="4" autocomplete="off" name="uname" title required></textarea> -->
                  <textarea id="apptnote" v-model="note" rows="4" autocomplete="off" name="uname" required
                    v-on:keyup="liveCountDown" maxlength="250"></textarea>

                  <div class="hide-bar-hold"></div>
                  <label for="fname">
                    <b>{{ $t('Note') }}</b>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <span v-html="errormessage" v-if="iserrormessage" style="color:red;width:98%;"
            class="error-message pull-left"></span>
        </div>

        <!-- modal body -->
        <div class="modal-footer">
          <!-- <button type="button" class="btn btn-default" data-dismiss="modal">Close</button> -->
        </div>
      </div>
    </div>
    <div v-if="monepopup">
      <monecreation @closepopupone="closecreationpopup"></monecreation>
    </div>
    <div v-if="appointmentspinner">
      <div class="processing_popup full-spinner" style="visibility: visible;">
        <div class="spinner">
          <div class="bounce1"></div>
          <div class="bounce2"></div>
          <div class="bounce3"></div>
        </div>
      </div>
    </div>

    <transition name="fade">
      <Messages v-if="isdisplaymsg" :iserror="iserrormsg" :datamessage="sucessmsgtext" @closemsg="closeMessage"
        :isVisible="isdisplaymsg" />
    </transition>
  </div>
</template>

<script>
import moment from "moment";
import mastertype from "../../models/masters_type";
import Autocomplete from "v-autocomplete";
// import 'v-autocomplete/dist/v-autocomplete.css';
// import { mapActions, mapGetters, Store } from "vuex";
import Vue from "vue";
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import GuestTemplate from "../AutocompleteTemplate/GuestTemplate.vue";
import cstmselctor from "../GenericComponent/TimePicker.vue";
import Axios from "axios";
import rest_service from "@/api/rest_service";
import myWorker from '@/config'
import i18n from '@/plugin/i18n';
import Messages from "@/components/MessagePopup/Messages";
import QuicksetupAPI from "@/api/quicksetup";
import LocationItemTemplate from "@/components/AutocompleteTemplate/Geolocation.vue"

Vue.use(flatpickr);
Vue.use(Autocomplete);

var new_appointment = null;
var new_appointment_dateForDisplay;
var new_appointment_TodateForDisplay;
var is_recurring_based_on_week = false;
var selectedGender = "";
var genderOptions;
var recurring_date_text = "";
var recurring_week_text = "";
var recurring_until_date_display;
var new_appointment_not_after;
var selected_number_off_recurring;
var isUserItself = false;
var mastertypemodel = null;
var bookingdate = null;
var recurringdate = null;
var customer = null;
var searchText;
var note;
var new_appointment_Fromdate;
var selectedFromDate;
var selectedToDate;
var usertimefrom;
var disableAppointmentEdit;
var selectededitappointment;

var providerbaseurl = rest_service.baseURL;

export default {
  props: [
    "appointmentByEncounter",
    "abhaprofile",
    "mode",        // 'register' | 'edit'
    "patientData"    // guest object to pre-fill in edit mode
  ],
  components: { "app-selector": cstmselctor, Messages },
  data() {
    return {
      isupdated:false,
      isClosing:false,
      editnotallowed:false,
      isSaving: false,
      //guest
      _lastSelectedItem: null,
      isSelecting: false,
      guestCustomers: [],
      guestHasfocus: false,
      guestHasfocusout: false,
      guestHasfocusoutvalue: false,
      selectedGuest: "",
      registrationid: "",
      readonlyparentdata: false,
      IsAbha: false,
      customflag: false,
      patientPriority_Id: null,
      patientPriority: null,
      patientStatus_Id: null,
      patientStatus: null,
      hasLoadedTenantData: false,
      abhaNumber: "",
      abhaAddress: "",
      dobAsPerAbha: "",
      validationcustomeremail: false,
      showEmailConfirmModal: false,
      numbervalidationcustomer: false,
      getAppFromTime2: "",
      getAppToTime2: "",
      selectededitappointment,
      disableAppointmentEdit: false,
      getparent2: this,
      appointmentButtontext: "",
      getparent: this,
      myStep: 15,
      dateRange: true,
      new_appointment_Fromdate,
      isFromDateDisable: false,
      appointmentspinner: false,
      selectedFromDate: "",
      locationid: null,
      staffid: null,
      errormessage: "",
      iserrormessage: false,
      relationshipIsself: true,
      langselected: 'en',
      relationShipsArr: [
        { name: "Self", transname: "" },
        { name: "Son", transname: "" },
        { name: "Daughter", transname: "" },
        { name: "Mother", transname: "" },
        { name: "Mother-in-law", transname: "" },
        { name: "Father", transname: "" },
        { name: "Father-in-law", transname: "" },
        { name: "Husband", transname: "" },
        { name: "Wife", transname: "" },
        { name: "Brother", transname: "" },
        { name: "Sister", transname: "" },
        { name: "Grandfather", transname: "" },
        { name: "Grandmother", transname: "" },
        { name: "Friend", transname: "" },
        { name: "Other", transname: "" },
        { name: "Not Related", transname: "" }
      ],
      recurring_types: [
        { name: "Never", transname: "" },
        { name: "Every Day", transname: "" },
        { name: "Every Week", transname: "" },
        { name: "Every Month", transname: "" },
        { name: "Every Year", transname: "" }
      ],
      selected_recurring_types: "Never",
      mastertypemodel: mastertype.masters_type,
      recurrence_on: [],
      customers: [],
      customer,
      new_appointment: {},
      //recurrfpickr:[],
      is_recurring_based_on_week: false,
      selectedGender: "",
      genderOptions: [
        { text: this.$t('Male'), value: "male" },
        { text: this.$t('Female'), value: "female" },
        { text: this.$t('Other'), value: "other" }
      ],
      recurring_date_text,
      recurring_week_text,
      new_appointment_dateForDisplay,
      new_appointment_TodateForDisplay,
      new_appointment_not_after,
      recurring_until_date_display,
      selected_number_off_recurring,
      recurring_Days: [
        {
          name: "Sun",
          value: "Sunday",
          ischecked: true
        },
        {
          name: "Mon",
          value: "Monday",
          ischecked: true
        },
        {
          name: "Tue",
          value: "Tuesday",
          ischecked: true
        },
        {
          name: "Wed",
          value: "Wednesday",
          ischecked: true
        },
        {
          name: "Thu",
          value: "Thursday",
          ischecked: true
        },
        {
          name: "Fri",
          value: "Friday",
          ischecked: true
        },
        {
          name: "Sat",
          value: "Saturday",
          ischecked: true
        }
      ],
      recurrence_text_messsage: "",
      dateFormat: "DD-MM-YYYY",//"DD/MM/YYYY",
      calenderdateformat: "YYYY-MM-DD",
      new_appointment,
      customeremail: "",
      customerage: "",
      occur_text: "Occurs every ",
      customername: "",
      iscustomerprimary: false,
      isUserItself,
      customermobile: "",
      selectedBookingSource: "",
      selectedBookingstatus: [],
      note: "",
      recurringseldate: new Date(),
      limitmaxCount: 250,
      totalRemainCount: 0,
      bookingdate: "",
      recurringdate: "",
      bookingfromtime: this.bookingdate,
      bookingtotime: this.bookingdate,
      selectedclinicprovider: null,
      selectedlocation: null,
      selectedservice: null,
      providercliniclist: [],
      locationlist: [],
      servicelist: [],
      countrycode: "",
      formattedCountryCode: "+91",
      SLTPMap: [],
      mobHasfocus: false,
      mobHasfocusout: false,
      mobHasfocusoutvalue: true,
      patientname: "",
      parentuser: null,
      authenticationToken: null,
      loggedin_user_unique_id: null,
      appointmentsource: [],
      appointmentstatus: [],
      role_unique_id: null,
      gtemplate: GuestTemplate,
      disabledForWhomeForDependent: true,
      relationship: "Self",
      allowOverlapping: true,
      patient_RegId: null,
      patient_unique_id: null,
      customerdetails: {},
      agent_name: "",
      firstAppointment: "0",
      fullname: false,
      useremail: false,
      userpname: false,
      userprovider: false,
      userfacility: false,
      userservice: false,
      usertimefrom: false,
      patientnamevalidator: false,
      userstatus: false,
      usersource: false,
      usergender: false,
      usermobilenumber: false,
      telantid: "",
      monepopup: false,
      default_tenantinfo: [],
      isPrimaryCustomer: false,
      dtpFromDate: "",
      isupdateappt: false,
      iseditfrommidnight: false,
      showPatientConfirmModal: false,
      tempPatientData: null,
      selectedPatientData: null,
      has_registered: false,
      mobilenumberdigitisvalid: false,
      browser_country: "",
      isnextsource: false,
      firstName: "",
      middleName: "",
      lastName: "",
      age: "",
      numberofvisitors: "",
      autoCompleteAddress: null,
      address: "",
      addressHasfocus: false,
      addressHasfocusout: false,
      addressHasfocusoutvalue: false,
      addresses: [],
      locationTemplate: LocationItemTemplate,
      dateofbirth: "",
      isdisplaymsg: false,
      sucessmsgtext: "",
      iserrormsg: false,
      isfirstname: false,
      ismiddlename: false,
      islastname: false,
      isselecteddateofbirth: false,
      iscountrycode: false,
      validatedphnum: false,
      isdisablesource: false,
      fb: null
    };
  },
  created() {
    this.createdmethods();
  },
  computed: {
    isEditMode() {
      return this.mode === 'edit';
    },
    isAbhaEnabled() {
      const tenantObj = JSON.parse(sessionStorage.getItem('tenantObj'));
      if (!tenantObj || !tenantObj.nhA_ABDM) return false;
      return tenantObj.nhA_ABDM;
    },
  },
  methods: {
    populateEditFields(data) {
      this.firstName = data.firstname || "";
      this.middleName = data.middlename || "";
      this.lastName = data.lastname || "";
      this.customer = data.mobile || "";
      this.customermobile = data.mobile || "";
      this.customeremail = data.email || "";
      this.address = data.address || "";
      this.selectedGender = data.gender ? data.gender.toLowerCase() : "";
      this.patient_unique_id = data.unique_id || "";
      this.countrycode = data.country_code || "91";
      this.selectedGuest = data.patient_RegId || "";

      // Set DOB
      if (data.Date_of_birth) {
        this.dateofbirth = data.Date_of_birth;
        this.$nextTick(() => {
          if (this.fb) {
            this.fb.setDate(this.dateofbirth, true);
          }
        });
      }

      // Lock mobile and guest ID fields
      this.readonlyparentdata = true;

      // Keep labels floated
      this.mobHasfocus = true;
      this.mobHasfocusout = true;
      this.mobHasfocusoutvalue = true;
      this.guestHasfocusout = true;
      this.guestHasfocusoutvalue = true;
    },
    updateVIPGuest() {
      if (this.Validation()) {
        debugger
        var self = this;
        self.isupdated=true;
        self.isSaving = true;
        var vipGuest = {
          firstname: self.firstName,
          middlename: self.middleName,
          lastname: self.lastName,
          Date_of_birth: self.dateofbirth,
          email: self.customeremail,
          address: self.address,
          gender: self.selectedGender,
          unique_id: self.patient_unique_id,
          updatedby: self.loggedin_user_unique_id,
          age:self.age ? self.age : "",
          // mobile & guest ID intentionally omitted — not editable
        };
        self.appointmentspinner = true;
        self.vipUpdateAPI(vipGuest)
          .then(response => {
            self.isdisplaymsg = true;
            self.iserrormsg = false;
            self.sucessmsgtext = "Patient details updated successfully.";
            self.appointmentspinner = false;
            setTimeout(() => {
              self.closeBookAppointment('closepopup');
              self.isSaving = false;
            }, self.$store.state.helper.msgDisplayTime);
          })
          .catch(error => {
            self.appointmentspinner = false;
            self.iserrormessage = true;
            self.errormessage = error;
          });
      }
    },

    vipUpdateAPI(guestModel) {
      var api_url = providerbaseurl + "/patient-bed-management/patient-update"; // confirm endpoint with backend
      return Axios.request({
        method: "put",
        url: api_url,
        headers: {
          x_tenant_id: localStorage.tenantid,
          role_unique_id: this.role_unique_id,
          route_entity_name: "/Patient-bed-management",
          loggedin_user_unique_id: this.loggedin_user_unique_id,
          Authorization: this.authenticationToken
        },
        data: guestModel
      }).then(r => r.data);
    },
    hasValue(val) {
      return val !== null && val !== undefined && val.toString().trim() !== '';
    },
    allowDOBInput(e) {
      const allowedKeys = [
        'Backspace', 'Delete', 'Tab',
        'ArrowLeft', 'ArrowRight',
        'Home', 'End'
      ];

      if (allowedKeys.includes(e.key)) return;
      if ((e.ctrlKey || e.metaKey) && ['a', 'c', 'v', 'x'].includes(e.key.toLowerCase())) return;

      // Only digits and hyphen allowed
      if (!/^\d$/.test(e.key) && e.key !== '-') {
        e.preventDefault();
        return;
      }

      // ✅ Smart year digit validation (position-aware)
      if (/^\d$/.test(e.key)) {
        const input = e.target;
        const currentVal = input.value;
        const digitsOnly = currentVal.replace(/\D/g, '');

        // We're typing the year part (digits 5–8, index 4–7)
        if (digitsOnly.length >= 4) {
          const yearDigits = digitsOnly.slice(4); // year digits typed so far
          const newYearStr = yearDigits + e.key;  // what year will look like after this key

          const today = new Date();
          const currentYear = today.getFullYear();
          const minYear = currentYear - 199;

          // If year is fully typed (4 digits), validate range
          if (newYearStr.length === 4) {
            const typedYear = parseInt(newYearStr, 10);
            if (typedYear > currentYear || typedYear < minYear) {
              e.preventDefault();
              return;
            }
          }

          // ✅ Block clearly impossible year starts
          // e.g. year starting with 0 or 1 when minYear > 1999
          if (newYearStr.length === 1) {
            const firstDigit = parseInt(newYearStr, 10);
            const minFirstDigit = parseInt(String(minYear)[0], 10);
            const maxFirstDigit = parseInt(String(currentYear)[0], 10);
            if (firstDigit < minFirstDigit || firstDigit > maxFirstDigit) {
              e.preventDefault();
              return;
            }
          }
        }
      }
    },
    createdmethods() {
      this.getCountry();
      this.parentuser = JSON.parse(localStorage.getItem("loggedInUserInfo"));

      if (this.parentuser != null && this.parentuser.unique_id) {
        this.loggedin_user_unique_id = this.parentuser.unique_id;
        this.telantid = this.parentuser.tenant_id;

      }
      if (this.parentuser != null && this.parentuser.role) {
        this.role_unique_id = this.parentuser.role.unique_id;
      }
      // //localStorage.removeItem("stafflocationservicelist");

      this.agent_name =
        this.parentuser.first_name +
        (this.parentuser.last_name ? this.parentuser.last_name : "");


      this.appointmentButtontext = this.$t('Save');
      var tenantbusinesssetup = JSON.parse(window.localStorage.getItem("tenantbusinesssetup"));
      if (tenantbusinesssetup != null && tenantbusinesssetup.isdisablesource) {
        this.isdisablesource = tenantbusinesssetup.isdisablesource
      }
      if (window.localStorage.getItem("accesstoken")) {
        this.authenticationToken = window.localStorage.getItem("accesstoken");
      }
    },
    MountedMethods() {
      this.$nextTick(() => {
        const input = document.querySelector("#patientsetdateofbirth");
        const modalBody = document.querySelector("#PatientRegistrationModal .modal-body");

        this.fb = flatpickr(input, {
          dateFormat: "d-m-Y",
          maxDate: new Date(),
          allowInput: true,
          defaultDate: this.dateofbirth || null,
          appendTo: modalBody,
          onChange: (selectedDates, dateStr) => {
            this.dateofbirth = dateStr;
          },
          onReady: (selectedDates, dateStr, instance) => {
            const currentYear = new Date().getFullYear();
            const yearInput = instance.currentYearElement;

            if (yearInput) {
              yearInput.addEventListener("input", function () {
                const val = parseInt(this.value, 10);
                if (val > currentYear) this.value = currentYear;
              });
            }

            // one-time outside click close
            const closeHandler = (e) => {
              const calendar = instance.calendarContainer;
              if (calendar && !calendar.contains(e.target) && e.target !== input) {
                instance.close();
              }
            };

            document.addEventListener("mousedown", closeHandler);

            // cleanup when modal closes
            const modal = document.querySelector("#PatientRegistrationModal");
            if (modal) {
              modal.addEventListener("hidden.bs.modal", () => {
                document.removeEventListener("mousedown", closeHandler);
              });
            }
          },
        });
      });
    },
    handleMobileInput(event) {
      let value = event.target.value;
      const cleaned = value.replace(/[^\d|]/g, '');

      if (value !== cleaned) {
        event.target.value = cleaned;
        this.numbervalidationcustomer = true;
      } else {
        this.numbervalidationcustomer = false;
      }

      this.customermobile = cleaned;

      this.mobHasfocusoutvalue = cleaned.length > 0;

      // Length validation only if user has typed something
      this.mobilenumberdigitisvalid = cleaned.length > 0 && cleaned.length !== 10;
    },
    registerVIPGuest() {
      if (this.Validation()) {
        window.localStorage.removeItem("bedallocation_patient");
        var self = this;
        self.isSaving = true;
        var bedallocation_patient = {};
        bedallocation_patient = {
          firstname: self.firstName,
          middlename: self.middleName,
          lastname: self.lastName,
          mobile: self.customermobile,
          country_code: self.countrycode,
          Date_of_birth: self.dateofbirth,
          email: self.customeremail,
          address: self.address,
          gender: self.selectedGender,
          unique_id: self.patient_unique_id,
          //createdby: self.loggedin_user_unique_id,
          age:self.age ? self.age : ""
        };
        self.appointmentspinner = true;
        self.vipRegisterAPI(bedallocation_patient)
          .then(responce => {
            
            self.$parent.$data.isdisplaymsg = false;
            self.isdisplaymsg = true;
            localStorage.setItem("bedallocation_patient", JSON.stringify(responce.value));
            self.appointmentspinner = false;
            self.iserrormsg = false;
            self.sucessmsgtext = "Data saved successfully.";
            setTimeout(() => {
              self.closeBookAppointment('closepopup');
              self.isSaving = false;
              self.$router.push({
                path:
                  "/bed-allocation/patient"
              });
            }, self.$store.state.helper.msgDisplayTime);
          })
          .catch(function (error) {
            self.appointmentspinner = false;
            self.iserrormessage = true;
            self.errormessage = error;
          });
      }
    },
    vipRegisterAPI(appointmentmodel) {

      var api_url = providerbaseurl + "/Patient-bed-management/patient-register";
      return Axios.request({
        method: "post",
        url: api_url,
        headers: {
          x_tenant_id: localStorage.tenantid,
          role_unique_id: this.role_unique_id,
          route_entity_name: "/Patient-bed-management",
          loggedin_user_unique_id: this.loggedin_user_unique_id,
          Authorization: this.authenticationToken
        },
        withCredentials: false,
        data: appointmentmodel
      })
        .then(response => {
          return response.data;
        })
        .catch(function (error) {
          return error;
        });
    },
    allowGuestIdChars(e) {
      //  Use e.key directly — keyCode is deprecated and unreliable
      var key = e.key;

      // Allow control keys: backspace, delete, arrows, tab
      if (key === "Backspace" || key === "Delete" || key === "Tab" ||
        key === "ArrowLeft" || key === "ArrowRight" || key === "Home" || key === "End") {
        return;
      }

      if (!/^[a-zA-Z0-9-]$/.test(key)) {
        e.preventDefault();
      }
    },


    checkValue(e) {
      if (this.isClosing) return;
      if (this.isSelecting) {
        this.numbervalidationcustomer = false;
        return;
      }
      if (e === null || typeof e === "object") {
        this.numbervalidationcustomer = false;
        this.mobHasfocusoutvalue = e !== null;
        return;
      }
      if (!e || e === "") {
        this.numbervalidationcustomer = false;
        this.mobHasfocusoutvalue = false; 
        return;
      }

      this.mobHasfocusoutvalue = true;

      if (!/^[\d|]*$/.test(e)) {
        this.numbervalidationcustomer = true;
      } else {
        this.numbervalidationcustomer = e.length !== 10;
      }
      this.customermobile = e;
    },

    getLabel(item) {
      if (item === null || item === undefined) {
        const inputEl = this.$refs.newCustomer_autocomplete &&
          this.$refs.newCustomer_autocomplete.$el &&
          this.$refs.newCustomer_autocomplete.$el.querySelector('input');
        if (inputEl && inputEl.value) {
          return inputEl.value;
        }
        return '';
      }
      if (typeof item === "string") return item;
      if (typeof item === "object") return item.mobile || "";
      return "";
    },

    customer_selected(item) {
      if (!item || typeof item !== "object") return;

      this.numbervalidationcustomer = false;
      this.applySelectedPatient(item, "mobile");
      this.readonlyparentdata=true;
      this.guestHasfocusout = true;
      this.mobHasfocus = true;
      this.mobHasfocusout = true;
      this.guestHasfocusoutvalue = true;
    },

    applySelectedPatient: function (item, type) {
      if (!item) return;

      this._lastSelectedItem = item;
      this.isSelecting = true; //  blocks ALL watchers above

      //  Clear all validation flags immediately
      this.numbervalidationcustomer = false;
      this.mobilenumberdigitisvalid = false;
      this.isfirstname = false;
      this.ismiddlename = false;
      this.validationcustomeremail = false;

      //  Set all fields — watchers are blocked so no interference
      this.firstName = item.firstname || "";
      this.lastName = item.lastname || "";
      this.middleName = item.middlename || "";

      if (!item.firstname && item.name) {
        const parts = item.name.trim().split(/\s+/);

        this.firstName = parts[0] || "";
        this.middleName = parts.length > 2 ? parts.slice(1, -1).join(" ") : "";
        this.lastName = parts.length > 1 ? parts[parts.length - 1] : "";
      }
      this.customeremail = item.email || "";
      this.customermobile = item.mobile || "";
      this.address = item.address || "";
      this.patient_unique_id = item.unique_id || "";

      if (item.date_of_birth && this.fb) {
        this.dateofbirth = item.date_of_birth;
        this.fb.setDate(this.dateofbirth, true);
      }

      if (item.gender) {
        this.selectedGender = item.gender.toLowerCase();
      }
      
      this.customer = item.mobile || "";
      this.selectedGuest = item.patient_RegId || "";

      var self = this;
      this.$nextTick(function () {
        // Force DOM inputs
        var mobileInput = document.getElementById("registerpatientautoselect");
        if (mobileInput) mobileInput.value = item.mobile || "";

        var guestInput = document.getElementById("patientid_autocomplete");
        if (guestInput) guestInput.value = item.patient_RegId || "";

        // Force autocomplete internal searchText
        if (self.$refs.newCustomer_autocomplete && self.$refs.newCustomer_autocomplete._data) {
          self.$refs.newCustomer_autocomplete._data.searchText = item.mobile || "";
        }
        if (self.$refs.guest_autocomplete && self.$refs.guest_autocomplete._data) {
          self.$refs.guest_autocomplete._data.searchText = item.patient_RegId || "";
        }

        //  Release lock AFTER next paint cycle completes
        setTimeout(function () {
          self.isSelecting = false;
          self._lastSelectedItem = null;
          // Clear validation once more after lock releases
          self.numbervalidationcustomer = false;
          self.mobilenumberdigitisvalid = false;
        }, 600);
      });
    },
    updateItems(text) {
      if (this.isSelecting) {
        if (this._lastSelectedItem) {
          var input = document.getElementById("registerpatientautoselect");
          if (input) input.value = this._lastSelectedItem.mobile || "";
        }
        return;
      }
      if (typeof text !== "string") return;
      this.usermobilenumber = false;
      //  Strip non-digits here instead of blocking in keypress
      var digitsOnly = text.replace(/[^0-9]/g, "");

      //  If stripping changed the value, update the DOM input directly
      if (digitsOnly !== text) {
        var input = document.getElementById("registerpatientautoselect");
        if (input) input.value = digitsOnly;
        // also sync component internal state
        if (this.$refs.newCustomer_autocomplete && this.$refs.newCustomer_autocomplete._data) {
          this.$refs.newCustomer_autocomplete._data.searchText = digitsOnly;
        }
        // don't search with invalid text
        if (!digitsOnly || digitsOnly.length < 4) {
          this.customers = [];
          return;
        }
        this.searched_customers_byMobileNumber(this.countrycode, digitsOnly);
        return;
      }

      if (!text || text.length < 4) {
        this.customers = [];
        return;
      }
      this.searched_customers_byMobileNumber(this.countrycode, text);
    },

    updateGuestItems(text) {
      if (this.isSelecting) {
        if (this._lastSelectedItem) {
          var input = document.getElementById("patientid_autocomplete");
          if (input) input.value = this._lastSelectedItem.patient_RegId || "";
        }
        return;
      }
      if (typeof text !== "string") return;
      if (!text) {
        this.guestCustomers = [];
        return;
      }

      //  Strip invalid chars here instead of blocking in keypress
      var formatted = text.replace(/[^A-Za-z0-9\- ]/g, "");

      //  Only touch DOM if something was actually stripped — don't interfere with normal typing
      if (formatted !== text) {
        var input = document.getElementById("patientid_autocomplete");
        if (input) input.value = formatted;
      }

      if (formatted.length >= 4) {
        this.searched_customers_byguestId(formatted);
      } else {
        this.guestCustomers = [];
      }
    },
    guestfocus(value) {
      this.guestHasfocus = value;
      if (!value) {
        this.guestHasfocusout = true;
        // Check string, object, or raw input value
        if (typeof this.selectedGuest === "string") {
          this.guestHasfocusoutvalue = this.selectedGuest.trim() !== "";
        } else if (this.selectedGuest !== null && typeof this.selectedGuest === "object") {
          this.guestHasfocusoutvalue = true; // object means a guest was selected
        } else {
          // Fallback: check raw DOM input in case label binding hasn't updated yet
          var inputEl = this.$refs.guest_autocomplete &&
            this.$refs.guest_autocomplete.$el &&
            this.$refs.guest_autocomplete.$el.querySelector('input');
          this.guestHasfocusoutvalue = !!(inputEl && inputEl.value && inputEl.value.trim() !== "");
        }
      } else {
        this.guestHasfocusoutvalue = true; // always float label on focus
      }
    },

    getGuestLabel(item) {
      if (item === null || item === undefined) {
        const inputEl = this.$refs.guest_autocomplete &&
          this.$refs.guest_autocomplete.$el &&
          this.$refs.guest_autocomplete.$el.querySelector('input');
        if (inputEl && inputEl.value) {
          return inputEl.value;
        }
        return '';
      }
      if (typeof item === "string") return item;
      if (typeof item === "object") return item.patient_RegId || "";
      return "";
    },

    guest_selected(item) {
      if (!item || typeof item !== "object") return;
      
      this.applySelectedPatient(item, "guest");
      this.guestHasfocusout = true;
      this.readonlyparentdata=true;
      this.guestHasfocusoutvalue = true;
      this.mobHasfocus = true;
      this.mobHasfocusout = true;
    },

    addressFocus(value) {
      this.addressHasfocus = value;
      if (value == false) {
        this.addressHasfocusout = true;
        const addressInput = this.$refs.geoLocation_autocomplete.$el.querySelector('input');
        const addressValue = addressInput ? addressInput.value.trim() : "";
        console.log(addressValue);
        this.addressHasfocusoutvalue = addressValue !== "";
      }
    },


    onDobEnter(event) {
      this.calculateAge();
      if (event.key === "Enter") {
        const isValid = this.validateDOBInput(event);
        if (isValid && this.fb) {
          this.fb.close();
        }
      }
    },
    allowNameKeyPress(event) {
      const char = String.fromCharCode(event.which);
      const allowed = /^[A-Za-z ]+$/; // alphabets, space, apostrophe, dot, hyphen
      if (!allowed.test(char)) {
        this.sucessmsgtext = this.$t("Pleaseenteralpahabetical");
        this.isdisplaymsg = true;
        this.iserrormsg = true;
        setTimeout(() => {
          this.closeMessage();
        }, this.$store.state.helper.msgDisplayTime);
        event.preventDefault();
      }
    },
    closeMessage() {
      this.isdisplaymsg = false;
      this.iserrormsg = false;
    },
    ValidateEmail() {

      this.parentuser = JSON.parse(localStorage.getItem("loggedInUserInfo"));
      if (window.localStorage.getItem("accesstoken")) {
        this.authenticationToken = window.localStorage.getItem("accesstoken");
      }

      if (this.parentuser != null && this.parentuser.unique_id) {
        this.loggedin_user_unique_id = this.parentuser.unique_id;
        this.telantid = this.parentuser.tenant_id;
      }

      if (this.parentuser != null && this.parentuser.role) {
        this.role_unique_id = this.parentuser.role.unique_id;
      }

      const api_url = providerbaseurl + "/reception/duplicate-email-check";

      return Axios.request({
        method: "get",
        url: api_url,
        headers: {
          x_tenant_id: this.telantid,
          role_unique_id: this.role_unique_id,
          route_entity_name: "/reception",
          loggedin_user_unique_id: this.loggedin_user_unique_id,
          Authorization: this.authenticationToken
        },
        params: {
          email: this.customeremail
        }
      })
        .then(response => {
          if (response.data.isDuplicate) {
            this.showEmailConfirmModal = true;
            this.$nextTick(() => {
              $("#email-confirm-pop").modal("show");
            });
          }
        })
        .catch(function (error) {
          console.error("Error checking email:", error);
        });
    },

    // ...mapActions(["ac_get_masters"]),
    closecreationpopup(element) {
      // this.bookappointment = false;
      if (element != "closepopup") {
        this.monepopup = false;
        //  $(".modal-backdrop").remove();

      }
    },
    navigatetomoneverify() {
      this.closeBookAppointment('closepopup');
      this.$router.push({
        path:
          "/abhaverify"
      });
    },
    navigatetomonecreate() {
      this.closeBookAppointment('closepopup');
      this.$router.push({
        path:
          "/abhacreation"
      });
    },
    allowOnlyDigits(e) {
      if (this.isClosing) return;
      const char = String.fromCharCode(e.charCode);
      if (!/^[0-9]$/.test(char)) {
        this.sucessmsgtext = this.$t("Onlynumericareallowed");
        this.isdisplaymsg = true;
        this.iserrormsg = true;
        setTimeout((xy) => {
          this.closeMessage();
        }, this.$store.state.helper.msgDisplayTime);
        e.preventDefault();
      }
    },
    OnlyNumeric(data) {
      return data.replace(/[^0-9|]/g, "");
    },
    async translations(name, lng) {
      try {
        let response = await rest_service.GoogleTranslate(name, lng);
        return response.translations[0].translatedText;
      } catch (error) {
        console.error("Translation error: ", error);
        return name; // Fallback to original name in case of error
      }
    },

    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else if (evt.currentTarget._value.length >= 3) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    searched_customers_byMobileNumber(countrycode, mobilenumber) {
      //
      //var role_unique_id = "";
      this.parentuser = JSON.parse(localStorage.getItem("loggedInUserInfo"));
      if (window.localStorage.getItem("accesstoken")) {
        this.authenticationToken = window.localStorage.getItem("accesstoken");
      }

      if (this.parentuser != null && this.parentuser.unique_id) {
        this.loggedin_user_unique_id = this.parentuser.unique_id;
        this.telantid = this.parentuser.tenant_id;

      }
      if (this.parentuser != null && this.parentuser.role) {
        this.role_unique_id = this.parentuser.role.unique_id;
      }
      var api_url = providerbaseurl + "/customer/getcustomersbymobile";
      // if (this.parentuser) {
      //   if (this.parentuser.role) {
      //     role_unique_id = this.parentuser.role.unique_id;
      //   }
      // }
      var self = this;
      return Axios.request({
        method: "get",
        url: api_url,
        headers: {
          x_tenant_id: this.telantid,
          role_unique_id: this.role_unique_id,
          route_entity_name: "/customer",
          loggedin_user_unique_id: this.loggedin_user_unique_id,
          Authorization: this.authenticationToken
        },
        withCredentials: false,
        params: {
          country_code: countrycode,
          mobile: mobilenumber
        }
      })
        .then(response => {
          self.customers = response.data.result;
        })
        .catch(function (error) {
          return error;
        });
    },
    searched_customers_byguestId(guestid) {
      //
      //var role_unique_id = "";
      this.parentuser = JSON.parse(localStorage.getItem("loggedInUserInfo"));
      if (window.localStorage.getItem("accesstoken")) {
        this.authenticationToken = window.localStorage.getItem("accesstoken");
      }

      if (this.parentuser != null && this.parentuser.unique_id) {
        this.loggedin_user_unique_id = this.parentuser.unique_id;
        this.telantid = this.parentuser.tenant_id;

      }
      if (this.parentuser != null && this.parentuser.role) {
        this.role_unique_id = this.parentuser.role.unique_id;
      }
      var api_url = providerbaseurl + "/customer/getcustomersbyregister_id";
      // if (this.parentuser) {
      //   if (this.parentuser.role) {
      //     role_unique_id = this.parentuser.role.unique_id;
      //   }
      // }
      var self = this;
      return Axios.request({
        method: "get",
        url: api_url,
        headers: {
          x_tenant_id: this.telantid,
          role_unique_id: this.role_unique_id,
          route_entity_name: "/customer",
          loggedin_user_unique_id: this.loggedin_user_unique_id,
          Authorization: this.authenticationToken
        },
        withCredentials: false,
        params: {
          registerid: guestid
        }
      })
        .then(response => {
          self.guestCustomers = response.data.result;
        })
        .catch(function (error) {
          return error;
        });
    },
    updateDOBItems() {
      //this.searched_customers_byMobileNumberAndDOB(this.countrycode, this.customermobile);
    },

    //End autocomplete
    shownote() {
      $(".add-categoryst").slideToggle();
      $("#add_category i.material-icons").toggleClass("open");
    },

    mobfocus(value) {
      this.mobHasfocus = value;
      if (value == false) {
        this.mobHasfocusout = true;

        // Check both the DOM input value AND the component model
        const inputEl = document.getElementById("registerpatientautoselect");
        const mobilevalue = inputEl ? inputEl.value : "";

        // Keep label elevated if there's ANY value (even partial)
        if (mobilevalue !== "" || this.customermobile !== "" || this.customer !== null) {
          this.mobHasfocusoutvalue = true;
        } else {
          this.mobHasfocusoutvalue = false;
        }
      }
    },

    closeBookAppointment(element) {
      this.isClosing = true;
      this._lastSelectedItem="";
      this.readonlyparentdata = false;

      this.selectedGender = "";        
      this.customer = "";              
      this.selectedGuest = "";        
      this.guestCustomers = [];       
      this.customers = [];            

      this.firstName = "";            
      this.middleName = "";
      this.lastName = "";
      this.address = "";
      this.dateofbirth = "";
      this.customeremail = "";         
      this.customermobile = "";       

      this.patient_unique_id = "";     

      this.numbervalidationcustomer = false;
      this.mobilenumberdigitisvalid = false;
      this.isfirstname = false;
      this.ismiddlename = false;
      this.validationcustomeremail = false;
      this.usermobilenumber = false;
      this.usergender = false;

      this.mobHasfocus = false;
      this.mobHasfocusout = false;
      this.mobHasfocusoutvalue = false;
      this.guestHasfocus = false;
      this.guestHasfocusout = false;
      this.guestHasfocusoutvalue = false;

      var self = this;
      this.$nextTick(function () {
        if (self.$refs.newCustomer_autocomplete && self.$refs.newCustomer_autocomplete._data) {
          self.$refs.newCustomer_autocomplete._data.searchText = "";
        }
        if (self.$refs.guest_autocomplete && self.$refs.guest_autocomplete._data) {
          self.$refs.guest_autocomplete._data.searchText = "";
        }

        if (self.fb) {
          self.fb.clear();
        }
        self.mobilenumberdigitisvalid = false;
        self.numbervalidationcustomer = false;
        self.isClosing = false;
      });
      this.MountedMethods();
      this.createdmethods();
      $('body').removeClass('modal-open');
      $('.modal-backdrop').remove();
      this.isupdated ? this.$emit('patientUpdated', "true") :
      this.$emit("closepopup", element);
      this.isupdated=false;
      return false;
    },
    ///Start new Code

    setCcode($event) {
      this.countrycode = $event.target.value;
      this.formattedCountryCode = "+" + this.countrycode.trim();
    },

    getCountry() {
      var self = this;
      this.browser_country = "IN";
      let urlip = "https://api.ipgeolocation.io/ipgeo?apiKey=a86929715b35444b916015f1f1112bac";
      var config = {
        method: "get",
        url: "https://api.ipify.org/?format=json",
      };
      Axios(config)
        .then(function (response) {
          if (response && response.data && response.data.ip) {
            console.log("IP=>", JSON.stringify(response.data));
            //url = url+response.data.ip;
            let cnfg = {
              method: "get",
              url: urlip + "&ip=" + response.data.ip,
            };

            Axios(cnfg)
              .then((response) => {
                if (response && response.data && (response.data.countryCode || response.data.country_code2)) {
                  if (response.data.country_code2) {
                    self.browser_country = response.data.country_code2;
                    self.countrycode = Number(
                      response.data.calling_code
                    );
                  }
                }
              })
              .catch((e) => {
                console.log("Could not detect any country!", e);
              });
          }
        })
        .catch(function (error) {
          console.log("could not get the ip", error);
        });
      if (!self.countrycode) {
        self.countrycode = Number("+91");
      }
    },
    ///
    calculateAge() {
      if (!this.dateofbirth) return;

      // Expecting format DD-MM-YYYY
      const parts = this.dateofbirth.split('-');
      if (parts.length !== 3) return;

      const day = parseInt(parts[0]);
      const month = parseInt(parts[1]) - 1; // months are 0-indexed
      const year = parseInt(parts[2]);

      const dob = new Date(year, month, day);
      const today = new Date();

      let age = today.getFullYear() - dob.getFullYear();
      const monthDiff = today.getMonth() - dob.getMonth();

      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < dob.getDate())
      ) {
        age--;
      }

      this.age = age;
    },
    allowOnlyNumbers(event) {
      const keyCode = event.keyCode ? event.keyCode : event.which;
      const keyValue = String.fromCharCode(keyCode);
      const isNumber = /^[0-9]+$/.test(keyValue);
      if (!isNumber) {
        this.sucessmsgtext = this.$t("Onlynumericareallowed");
        this.isdisplaymsg = true;
        this.iserrormsg = true;
        setTimeout((xy) => {
          this.closeMessage();
        }, this.$store.state.helper.msgDisplayTime);
        event.preventDefault();
      }
    },

    Validation() {
      debugger
      const onlyAlphabets = /^[A-Za-z\s\-.,']*$/;

      if (!this.firstName || !this.firstName.trim() || !onlyAlphabets.test(this.firstName.trim())) {
        this.isfirstname = true;
      } else {
        this.isfirstname = false;
      }

      const validDatePattern = /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-(\d{4})$/;

      if (this.dateofbirth) {
        if (!validDatePattern.test(this.dateofbirth)) {
          this.sucessmsgtext = "Invalid date format. Please enter as DD-MM-YYYY.";
          this.isdisplaymsg = true;
          this.iserrormsg = true;
          setTimeout(() => { this.closeMessage(); }, this.$store.state.helper.msgDisplayTime);
          this.isselecteddateofbirth = true;
          return; 
        }

        const [dayStr, monthStr, yearStr] = this.dateofbirth.split('-');
        const day = parseInt(dayStr, 10);
        const month = parseInt(monthStr, 10);
        const year = parseInt(yearStr, 10);
        const date = new Date(year, month - 1, day);

        if (
          date.getFullYear() !== year ||
          date.getMonth() + 1 !== month ||
          date.getDate() !== day
        ) {
          this.sucessmsgtext = "Invalid calendar date. Please enter a real date.";
          this.isdisplaymsg = true;
          this.iserrormsg = true;
          setTimeout(() => { this.closeMessage(); }, this.$store.state.helper.msgDisplayTime);
          this.isselecteddateofbirth = true;
          return;
        }

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        if (date > today) {
          this.sucessmsgtext = "Date of Birth cannot be in the future.";
          this.isdisplaymsg = true;
          this.iserrormsg = true;
          setTimeout(() => { this.closeMessage(); }, this.$store.state.helper.msgDisplayTime);
          this.isselecteddateofbirth = true;
          return;
        }

        const minAllowedDate = new Date();
        minAllowedDate.setFullYear(minAllowedDate.getFullYear() - 199);
        minAllowedDate.setHours(0, 0, 0, 0);
        if (date < minAllowedDate) {
          this.sucessmsgtext = "Date of Birth cannot be more than 199 years ago.";
          this.isdisplaymsg = true;
          this.iserrormsg = true;
          setTimeout(() => { this.closeMessage(); }, this.$store.state.helper.msgDisplayTime);
          this.isselecteddateofbirth = true;
          return;
        }

        this.isselecteddateofbirth = false;
      }


      if (this.customeremail != null && this.customeremail !== "" && !this.customeremail.trim()) {
        this.useremail = true;
      } else {
        this.useremail = false;
        //this.ValidateEmail();
      }
      if (this.selectedGender == "") {
        this.usergender = true;
      } else this.usergender = false;
      
      if (!this.selectededitappointment) {
        if (document.getElementById("registerpatientautoselect") && document.getElementById("registerpatientautoselect").value == "") {
          this.usermobilenumber = true;
        } else this.usermobilenumber = false;
        if (this.IsAbha) {
          if (this.customermobile == "") {
            this.usermobilenumber = true;
          } else this.usermobilenumber = false;
        }
      }
      //  isPnvalid=validationform.ValidateMandatory("patientname","errorpatientname","patient name","");
      if (
        !this.isfirstname &&
        !this.validationcustomeremail &&
        !this.usergender &&
        !this.usermobilenumber &&
        !this.mobilenumberdigitisvalid &&
        !this.numbervalidationcustomer &&
        !this.ismiddlename
      ) {
        return true;
      } else {
        return false;
      }
    },

    liveCountDown: function () {
      if (this.note.trim().length > this.limitmaxCount) {
        this.note = this.note.trim().substring(0, this.limitmaxCount);
      } else {
        // this.totalRemainCount = this.limitmaxCount-this.note.trim().length;
        this.totalRemainCount = this.note.trim().length;
      }
    },


    validateMobileNumber(inputtxt) {
      var phoneno = /^\d{10}$/;
      if ((inputtxt.match(phoneno))) {
        return true;
      }
      else {
        return false;
      }
    },
    VariableLength(data, totallength) {
      if (data.length == totallength) {
        return true;
      } else {
        return false;
      }
    },
    // getSelectedService(event) {
    //   console.log("Selected Service>>>", event.target.value);
    // },
    validateNameField(fieldName, flagName) {
      const val = this[fieldName];
      const onlyAlphabets = /^[A-Za-z\s\-.,']*$/;
      this[flagName] = val && val.length > 0 && !onlyAlphabets.test(val.toLowerCase());
    },
    validateDOBInput(event) {
      let value = event.target.value;
      if (!value || value.trim() === "") {
        this.dateofbirth = "";
        return false;
      }
      //Step 1: Clean input — allow digits and `/` or `-`, convert `/` to `-`
      let cleaned = value.replace(/[^0-9\/]/g, '').trim().replace(/\//g, '-');
      const digitsOnly = cleaned.replace(/-/g, '');

      if (digitsOnly.length === 0) {
        this.sucessmsgtext = "Please enter a valid date in DD-MM-YYYY format.";
        this.isdisplaymsg = true;
        this.iserrormsg = true;
        this.Date_of_birth = '';
        event.target.value = '';
        setTimeout(() => {
          this.closeMessage();
        }, this.$store.state.helper.msgDisplayTime);
        return false;
      }

      //Step 2: Skip auto-formatting if input is too short
      if (digitsOnly.length < 3) {
        event.target.value = cleaned;
        this.dateofbirth = cleaned;
        return false;
      }

      //Step 3: Auto-insert '-' after DD and MM
      const separator = '-';
      const day = digitsOnly.slice(0, 2);
      const month = digitsOnly.slice(2, 4);
      const year = digitsOnly.slice(4, 8);
      cleaned = day + (month ? separator + month : '') + (year ? separator + year : '');

      event.target.value = cleaned;
      this.dateofbirth = cleaned;

      // Step 4: Validation - Mixed separators check
      if (cleaned.includes('/') && cleaned.includes('-')) {
        this.sucessmsgtext = "Please use only '-' consistently in the date.";
        this.isdisplaymsg = true;
        this.iserrormsg = false;
        this.dateofbirth = '';
        event.target.value = '';
        setTimeout(() => {
          this.closeMessage();
        }, this.$store.state.helper.msgDisplayTime);
        return false;
      }

      // Step 5: Validate date format using RegEx (DD-MM-YYYY)
      const validDatePattern = /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-(\d{4})$/;

      if (cleaned.length >= 10 && !validDatePattern.test(cleaned)) {
        this.sucessmsgtext = "Invalid date format. Please enter as DD-MM-YYYY.";
        this.isdisplaymsg = true;
        this.iserrormsg = true;
        setTimeout(() => {
          this.closeMessage();
        }, this.$store.state.helper.msgDisplayTime);
        this.dateofbirth = '';
        event.target.value = '';
        setTimeout(() => {
          this.closeMessage();
        }, this.$store.state.helper.msgDisplayTime);
        return false;
      }

      // Step 6: Validate real calendar date
      if (validDatePattern.test(cleaned)) {
        const [dayStr, monthStr, yearStr] = cleaned.split('-');
        const day = parseInt(dayStr, 10);
        const month = parseInt(monthStr, 10);
        const year = parseInt(yearStr, 10);

        const date = new Date(year, month - 1, day);

        if (
          date.getFullYear() !== year ||
          date.getMonth() + 1 !== month ||
          date.getDate() !== day
        ) {
          this.sucessmsgtext = "Invalid calendar date. Please enter a real date.";
          this.isdisplaymsg = true;
          this.iserrormsg = true;
          this.dateofbirth = '';
          event.target.value = '';
          setTimeout(() => {
            this.closeMessage();
          }, this.$store.state.helper.msgDisplayTime);
          return false;
        }

        const today = new Date();
        if (date > today) {
          this.sucessmsgtext = "Date of Birth cannot be in the future.";
          this.isdisplaymsg = true;
          this.iserrormsg = true;
          this.dateofbirth = '';
          event.target.value = '';
          setTimeout(() => { this.closeMessage(); }, this.$store.state.helper.msgDisplayTime);
          return false;
        }

        // ✅ Step 7b: Check 199 year max age limit
        const minAllowedDate = new Date();
        minAllowedDate.setFullYear(minAllowedDate.getFullYear() - 199);
        if (date < minAllowedDate) {
          this.sucessmsgtext = "Date of Birth cannot be more than 199 years ago.";
          this.isdisplaymsg = true;
          this.iserrormsg = true;
          this.dateofbirth = '';
          event.target.value = '';
          setTimeout(() => { this.closeMessage(); }, this.$store.state.helper.msgDisplayTime);
          return false;
        }

        // Step 8: Valid date passed all checks
        this.dateofbirth = cleaned;
        return true;
      }
      return false;
    },
  },
  mounted() {
    if (this.selectedGuest) {
      this.guestHasfocusout = true;
      this.guestHasfocusoutvalue = true;
    }

    this.MountedMethods();
    window.localStorage.removeItem("bedallocation_patient");
    if (this.mode === 'edit' && this.patientData) {
      this.applySelectedPatient(this.patientData, 'edit');
      this.readonlyparentdata = true;
    }
  },
  watch: {
    // relation(newVal) {
    //   this.relationshipIsself = (newVal.toLowerCase() === "self");
    // },
    patientData: {
      immediate: true,
      handler(newVal) {
        if (this.mode === 'edit' && newVal) {
          this.$nextTick(() => {
            this.populateEditFields(newVal);
          });
        }
      }
    },
    abhaprofile: {
      immediate: true,
      handler(newValue) {
        if (newValue != null) {
          var self = this;
          self.abhaAddress = newValue.preferredAbhaAddress;
          self.abhaNumber = newValue.ABHANumber;
          self.dobAsPerAbha = newValue.dob,
            self.searched_customers_byMobileNumberforABHA("91", newValue.mobile);

          self.customermobile = newValue.mobile;
          self.customername = newValue.name;
          self.patientname = newValue.name;
          self.usermobilenumber = false;
          self.IsAbha = true;
          self.selectedGender = newValue.gender.toLowerCase().startsWith('m') ? 'male' : 'female';
        }
      }
    },
     customermobile: function (val) {
      if (this.isSelecting) return;

      val = val ? String(val) : '';

      // Remove non-numeric characters instantly
      const cleaned = value.replace(/[^\d|]/g, '');

      if (val !== cleaned) {
        this.customermobile = cleaned; // prevents alphabets/special chars from appearing
        this.numbervalidationcustomer = true;
      } else {
        this.numbervalidationcustomer = false;
      }

      // Length validation
      this.mobilenumberdigitisvalid = cleaned.length !== 10;
    },

    autoCompleteAddress(newVal) {
      if (newVal && newVal.trim() !== "") {
        this.addressHasfocusout = true;
        this.addressHasfocusoutvalue = true;
      } else {
        this.addressHasfocusoutvalue = false;
        this.addresses = {};
      }
    },
    customeremail: function () {
      if (this.isSelecting) return; //  ADD THIS
      var val = this.customeremail;
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (val && val.length > 0) {
        this.validationcustomeremail = !re.test(val.toLowerCase());
      } else {
        this.validationcustomeremail = false;
      }
    },
    firstName: function (val) {
      if (this.isSelecting) return; //  ADD THIS
      this.validateNameField('firstName', 'isfirstname');
    },
    middleName: function (val) {
      if (this.isSelecting) return; //  ADD THIS
      this.validateNameField('middleName', 'ismiddlename');
    },
    // lastName(val) {
    //   this.validateNameField('lastName', 'islastname');
    // },
    dateofbirth: function (newVal) {
      if (newVal && newVal.trim && newVal.trim() !== "") { 
        this.calculateAge();
      }
    },
    selectedGuest(val) {
      if (val) {
        this.guestHasfocusout = true;
        this.guestHasfocusoutvalue = true;
      } else {
        this.guestHasfocusoutvalue = false;
      }
    },
    customers: function (newVal) {
      if (this._lastSelectedItem && this.isSelecting) {
        var self = this;
        this.$nextTick(function () {
          if (self.$refs.newCustomer_autocomplete && self.$refs.newCustomer_autocomplete._data) {
            self.$refs.newCustomer_autocomplete._data.searchText =
              self._lastSelectedItem.mobile || "";
          }
        });
        return;
      }
      // Empty API response — set customermobile to typed value
      if (!newVal || newVal.length === 0) {
        var input = document.getElementById("registerpatientautoselect");
        var typedValue = input ? input.value : "";
        if (typedValue && typedValue.length >= 10) {
          this.customermobile = typedValue;
          this.numbervalidationcustomer = false;
          this.mobilenumberdigitisvalid = false;
        }
      }
    },
    guestCustomers: function (newVal) {
      if (this._lastSelectedItem && this.isSelecting) {
        var self = this;
        this.$nextTick(function () {
          if (self.$refs.guest_autocomplete && self.$refs.guest_autocomplete._data) {
            self.$refs.guest_autocomplete._data.searchText =
              self._lastSelectedItem.patient_RegId || "";
          }
        });
      }
    },
  },
  updated() {
    var self = this;


  }
};
</script>

<style scoped>
.numberofvisitor-label {
  font-size: 11px !important;
}

label.radio-container {
  width: auto !important;
  margin-right: 15px;
}

.modal-dialog.wider-1 .close {
  padding: 0;
  margin: 0;
  top: 2px;
  right: 8px;
}

#email-confirm-pop .modal-header {
  padding: 0;
  min-height: inherit;
}

#email-confirm-pop .modal-body {
  padding: 30px 30px 20px;
  text-align: center;
  margin: 0;
}

#email-confirm-pop .modal-body h6 {
  margin: 0 0 30px;
  font-size: 15px;
}

#email-confirm-pop .modal-body>div:last-child {
  justify-content: center;
  display: flex;
  grid-column-gap: 20px;
}

#email-confirm-pop.modal {
  z-index: 1052 !important;
}

#email-confirm-pop.modal:before {
  content: "";
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  left: 0;
}

#email-confirm-pop .modal-content {
  padding: 10px 0 !important;
}

#email-confirm-pop .modal-dialog.modal-dialog-centered {
  margin-top: 180px;
}

#patient-confirm-pop .modal-header {
  padding: 0;
  min-height: inherit;
}

#patient-confirm-pop .modal-body {
  padding: 30px 30px 20px;
  text-align: center;
  margin: 0;
}

#patient-confirm-pop .modal-body h6 {
  margin: 0 0 30px;
  font-size: 15px;
}

#patient-confirm-pop .modal-body>div:last-child {
  justify-content: center;
  display: flex;
  grid-column-gap: 20px;
}

#patient-confirm-pop.modal {
  z-index: 1052 !important;
}

#patient-confirm-pop.modal:before {
  content: "";
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  left: 0;
}

#patient-confirm-pop .modal-content {
  padding: 10px 0 !important;
}

#patient-confirm-pop .modal-dialog.modal-dialog-centered {
  margin-top: 180px;
}

@media (max-width:991px) {
  span.error-message.err-gender {
    margin-bottom: 15px;
  }

  .radio-container {
    margin-bottom: 16px;
  }

  .country-code {
    width: 100px;
  }

}

#registerpatientautoselect:disabled {
  color: rgba(29, 29, 29, 0.45) !important;
}
</style>
